import React from 'react';
import PropTypes from 'prop-types';

import CustomRadioButton from '../../util_components/custom_radio_button';
import TeacherCancelBucketPicker from '../../util_components/teacher_cancel_bucket_picker';
import { IST } from '../../util_components/care_request/care_request_rules';
import { GROUP_CANCEL_LABELS } from '../sessions/single_session_details/session_change_rules';
import { cancel_who_options, needs_teacher_time } from './group_cancel_rules';

// Who cancelled a group class or workshop, and (teacher, from 1 Nov 2026) when the teacher asked.
// Used by the group class page (workshops cancel there too); the host owns the state.
export function GroupCancelFields({
  sessionType,
  startEpoch,
  pick,
  requestedAt,
  timeError,
  whoErrorId,
  onPick,
  onRequestedAtChange,
  bookedAt
}) {
  const options = cancel_who_options(sessionType);
  // a friends class asks nothing (group_cancel_rules asks_who_cancelled)
  if (!options.length) return null;
  return (
    <>
      <div id="group-cancel-who-label" className="myt-form-label">
        Who cancelled? <span aria-hidden="true">*</span>
      </div>
      <div
        role="radiogroup"
        aria-labelledby="group-cancel-who-label"
        aria-required="true"
        aria-invalid={whoErrorId ? 'true' : undefined}
        aria-describedby={whoErrorId || undefined}
        className="myt-form-radios"
      >
        {options.map((option) => (
          <CustomRadioButton
            key={option}
            label={GROUP_CANCEL_LABELS[option]}
            onRadioClick={() => onPick(option)}
            selected={pick === option}
          />
        ))}
      </div>
      {needs_teacher_time(pick, startEpoch) ? (
        <TeacherCancelBucketPicker
          requestedAt={requestedAt}
          onRequestedAtChange={onRequestedAtChange}
          sessionStartEpoch={startEpoch}
          ianaTimezone={IST}
          timezoneLabel="IST"
          error={timeError}
          bookedAt={bookedAt}
        />
      ) : null}
    </>
  );
}

GroupCancelFields.propTypes = {
  sessionType: PropTypes.string,
  startEpoch: PropTypes.number,
  pick: PropTypes.string,
  requestedAt: PropTypes.string,
  timeError: PropTypes.bool,
  whoErrorId: PropTypes.string,
  onPick: PropTypes.func.isRequired,
  onRequestedAtChange: PropTypes.func.isRequired,
  bookedAt: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

GroupCancelFields.defaultProps = {
  sessionType: '',
  startEpoch: undefined,
  pick: '',
  requestedAt: '',
  timeError: false,
  whoErrorId: '',
  bookedAt: undefined
};

export default GroupCancelFields;
